// PUT Method
import { API_BASE_URL } from './apiBaseUrl';

export async function updateFavorites(userId, favorites) {
  const url = `${API_BASE_URL}/users/favorites/${userId}`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ favorites }),
  };
  try {
    await fetch(url, options);
  } catch (e) {
    console.error(e);
  }
}
